
import { post, put } from './index';

export const updateOrganization = (id, organizationData) => put(`/api/v1/admin/organizations/${id}`, {
  organization: organizationData,
}).then((response) => response.json());

export const switchOrganization = (organizationId) => post('/api/v1/set_session_organization', {
  organization_id: organizationId,
});
